var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-text-input',{attrs:{"label":_vm.$t('integrations.fields.user'),"readonly":true},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})}
var staticRenderFns = []

export { render, staticRenderFns }